import { type FunctionComponent } from 'react';
import { PlaceholderImage } from '../../images/placeholder-image/placeholder-image.component';
import { cardShadow } from '../search-product-card/search-product-card.css';

export type SearchProductCardSkeletonProps = {
	cardIndex: number;
};

export const SearchProductCardSkeleton: FunctionComponent<SearchProductCardSkeletonProps> = ({ cardIndex }) => (
	<div
		className={`'bg-theme-white bb-ns b--theme-grey-light relative' w-50 w-25-ns pv1 ${
			cardIndex % 2 === 0 ? 'pr1' : 'pl1'
		} pa2-ns mb3-ns`}
		data-testid="search-product-card-skeleton">
		<div className={`flex h-100 relative flex-column pa2 pa0-ns ba b--theme-grey-light br2 b--none-ns ${cardShadow}`}>
			{/* Image section */}
			<div className="aspect-ratio aspect-ratio--1x1 tc">
				<div className="aspect-ratio--object">
					<PlaceholderImage width={214} height={214} bypassLazyLoad />
				</div>
			</div>

			{/* Details section */}
			<div className="pt2 flex flex-column">
				{/* Swatches */}
				<div className="h2-ns flex-ns items-center-ns mb2">
					<div className="flex gap1">
						<PlaceholderImage className="br2" width={32} height={32} />
						<PlaceholderImage className="br2" width={32} height={32} />
						<PlaceholderImage className="br2" width={32} height={32} />
					</div>
				</div>

				{/* Brand and Title */}
				<div className="mb2">
					<PlaceholderImage className="br2 mb1" width={100} height={14} />
					<PlaceholderImage className="br2 mb1 w-100" height={16} />
					<PlaceholderImage className="br2 w-80" height={16} />
				</div>

				{/* Model number */}
				<PlaceholderImage className="br2 mb2" width={120} height={14} />

				{/* Star rating */}
				<PlaceholderImage className="br2 mb2" width={100} height={16} />

				{/* Price */}
				<PlaceholderImage className="br2 mb2" width={80} height={20} />

				{/* Shipping info */}
				<PlaceholderImage className="br2 mb2" width={150} height={14} />
			</div>
		</div>
	</div>
);

export type SearchProductCardSkeletonListProps = {
	count?: number;
};

export const SearchProductCardSkeletonList: FunctionComponent<SearchProductCardSkeletonListProps> = ({ count = 12 }) => {
	return (
		<div className="flex flex-wrap ml3-l" data-testid="search-product-card-skeleton-list">
			{Array.from({ length: count }).map((_, index) => (
				<SearchProductCardSkeleton key={index} cardIndex={index} />
			))}
		</div>
	);
};
